import { Reveal, SectionHeading } from "./Reveal";
import { useT } from "../context/ContentContext";
import { useUI } from "../lib/i18n";

export default function About({ content }) {
  const t = useT();
  const ui = useUI();
  return (
    <section id="chi-sono" className="relative py-28 md:py-40" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10 md:gap-16 items-center">
        <Reveal className="md:col-span-5">
          <div className="relative">
            <div className="absolute -top-10 -left-10 w-48 h-48 rounded-full bg-[#007AFF] opacity-20 blur-[90px] pointer-events-none" />
            <div className="relative border border-white/10 overflow-hidden group">
              <img
                src={content.about_image}
                alt={content.about_title}
                className="w-full aspect-[3/4] object-cover grayscale group-hover:grayscale-0 transition-[filter] duration-700"
                data-testid="about-image"
              />
              <div className="absolute bottom-0 inset-x-0 h-1/3 bg-gradient-to-t from-black/60 to-transparent" />
            </div>
          </div>
        </Reveal>
        <div className="md:col-span-7">
          <SectionHeading index="01" label={ui.about_label} title={t("about_title")} testid="about-title" />
          <Reveal delay={0.15}>
            <p className="mt-8 text-base md:text-lg text-zinc-400 leading-relaxed max-w-2xl whitespace-pre-line" data-testid="about-body">
              {t("about_body")}
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <div className="mt-10 flex flex-wrap gap-3">
              {ui.about_chips.map((chip) => (
                <span key={chip} className="font-mono text-xs tracking-widest uppercase border border-white/15 rounded-full px-4 py-2 text-zinc-400">
                  {chip}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
